var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSocialInstagram = function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.85 9.395c0-3.595 0-5.393.856-6.687a5.16 5.16 0 0 1 1.456-1.456C4.457.395 6.254.395 9.85.395c3.595 0 5.392 0 6.687.857a5.16 5.16 0 0 1 1.456 1.456c.857 1.294.857 3.092.857 6.687s0 5.393-.857 6.688a5.16 5.16 0 0 1-1.456 1.455c-1.295.857-3.092.857-6.687.857-3.596 0-5.393 0-6.688-.857a5.16 5.16 0 0 1-1.456-1.456C.85 14.788.85 12.99.85 9.395Zm13.659 0a4.66 4.66 0 1 1-9.319 0 4.66 4.66 0 0 1 9.319 0Zm-4.66 3.083a3.083 3.083 0 1 0 0-6.166 3.083 3.083 0 0 0 0 6.166Zm4.844-6.881a1.095 1.095 0 1 0 0-2.19 1.095 1.095 0 0 0 0 2.19Z",
    fill: "#fff"
  })));
};

export default SvgSocialInstagram;